export default __webpack_public_path__ + "static/media/MK-1920.aea2f89d.webp";